import { FaustTemplate } from '@faustwp/core';
import Head from 'next/head';
import Link from 'next/link';

import GetArchive from './archiveQuery.gql';
import { GetArchiveQuery } from '../../__generated__/graphql';
import EntryHeader from '../../components/EntryHeader';
import Footer from '../../layout/Footer';
import Header from '../../layout/Header';
import { gql } from '../helpers';

const Component: FaustTemplate<GetArchiveQuery> = props => {
  const { title: siteTitle } = props.data?.generalSettings ?? {};
  const headerLogo = props.data?.headerLogo?.nodes[0];
  const menuButton = props.data?.menuButton?.nodes[0] ?? {};
  const menuItems = props.data?.headerMenuItems?.nodes ?? [];
  const footerMenu = props.data?.footerMenus?.nodes[0];
  const systemAlert = props.data?.systemAlert?.nodes[0] ?? {};

  const nodeByUri = props.data?.nodeByUri;

  if (nodeByUri?.archiveType !== 'Category' && nodeByUri?.archiveType !== 'Tag') {
    return <>Archive not found</>;
  }

  const {
    archiveType,
    name,
    posts,
  } = nodeByUri;
  const htmlTitle = `${archiveType}: ${name ?? ''} - ${siteTitle ?? ''}`;

  return (
    <>
      <Head>
        <title>{htmlTitle}</title>
      </Head>

      <Header
        headerLogo={headerLogo}
        menuButton={menuButton}
        menuItems={menuItems}
        systemAlert={systemAlert}
      />

      <main className="container">
        <EntryHeader
          headerMenuItems={menuItems}
          title={`Archive for ${archiveType}: ${name ?? ''}`}
        />

        <h3>Recent Posts</h3>
        <ul>
          {posts?.nodes.map(post => (
            <Link
              href={post.uri ?? ''}
              key={post.id}
            >
              <li>{post.title}</li>
            </Link>
          ))}
        </ul>
      </main>

      {footerMenu && <Footer menu={footerMenu} />}
    </>
  );
};

Component.variables = seedQuery => {
  return {
    uri: seedQuery.uri,
  };
};

Component.query = gql(GetArchive);

export default Component;
